import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FaqAccordion from '../../../components/FaqAccordion';

const FaqSection = () => {
  const navigate = useNavigate();

  return (
    <section id="faq" className="marketing-section scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-12">
          <div
            className="brand-mark w-12 h-12 mx-auto mb-4"
          >
            <Icon name="HelpCircle" size={24} color="#FFFFFF" />
          </div>
          <h2 className="marketing-title text-3xl lg:text-5xl font-heading font-bold mb-4">
            Questions <span className="marketing-accent">fréquentes</span>
          </h2>
          <p className="marketing-muted text-lg">
            Prix, urgences, garanties — les réponses avant de commander.
          </p>
        </div>

        <FaqAccordion />

        <div className="text-center mt-8">
          <Button
            variant="default"
            size="lg"
            iconName="Calendar"
            onClick={() => navigate('/service-booking-wizard')}
          >
            Réserver une intervention
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
